module.exports = __webpack_public_path__ + "img/campbell.3f300fd3.png";